import './Settings.css';
import {useEffect, useState} from "react";
import Checkbox from "@mui/material/Checkbox";
import Modal from '../../../Modal/Modal.jsx'
import Validator from "../../../../Validator.js";
import InformationWidget from "../../../InformationWidget/InformationWidget.jsx";
import {getCustomerInfo, updateCustomerInfo} from "../../../../CustomerHandler.js";

export default function Settings() {
    useEffect(() => {
        const fetchCustomerInfo = async () => {
            const token = sessionStorage.getItem("customerAccessToken");
            if(!token) return;
            const data = await getCustomerInfo(token);

            setAccountSettings({
                name:data.firstName!==null ? data.firstName : "",
                surname:data.lastName!==null ? data.lastName : "",
                phone:data.phone!== null ? data.phone : "",
                email:data.email,
                receiveNewsletter: data.acceptsMarketing
            })

        }
        fetchCustomerInfo();
    }, []);

    const [accountSettings, setAccountSettings] = useState({
        name: "Sebastian",
        surname: "Kostrz",
        phone: "123123123",
        email: "email@email.com",
        receiveNewsletter: false,
    });

    const [areSettingsValid, setAreSettingsValid] = useState(true);

    const validateAccountSetting = () => {
        setAreSettingsValid(Validator.isEmpty(accountSettings.phone) ? true : Validator.isPhone(accountSettings.phone) ? true : "Numer telefonu nie jest poprawny")

    };


    const saveNewSettings = async () => {
        validateAccountSetting();
        // if (areSettingsValid === true) {
            const token = sessionStorage.getItem("customerAccessToken");
            if(!token) return;
            const data = await updateCustomerInfo(token, {
                firstName:accountSettings.name,
                lastName:accountSettings.surname,
                phone:accountSettings.phone,
                acceptsMarketing:accountSettings.receiveNewsletter,
            });
        window.location.reload();
        // }
    };


    const [showEmailForm, setShowEmailForm] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    useEffect(() => {
        document.body.style.overflow = showDeleteModal ? 'hidden' : '';
    }, [showDeleteModal]);

    return (
        <div className="settings">
            <h1 className="settings-title">Ustawienia konta</h1>

            <div className="settings-section">
                <h2 className="settings-subtitle">Dane konta</h2>
                <div className='settings-input-wrapper'>
                    <input type="text" className="settings-input" placeholder={`Imię: ${accountSettings.name}`}
                           onChange={(e) => setAccountSettings({...accountSettings, name: e.target.value})}/>
                </div>
                <div className="settings-input-wrapper">
                    <input type="text" className="settings-input" placeholder={`Nazwisko: ${accountSettings.surname}`}
                           onChange={(e) => setAccountSettings({...accountSettings, surname: e.target.value})}
                    />
                </div>
                <div className="settings-input-wrapper">
                    <input type="tel" className="settings-input" placeholder={`Telefon: ${accountSettings.phone}`}
                           onChange={(e) => setAccountSettings({...accountSettings, phone: e.target.value})}
                           style={{borderColor: areSettingsValid!==true ? 'red' : ''}}/>
                    {areSettingsValid !== true && <InformationWidget text={areSettingsValid}/>}
                </div>
                <div className="settings-box">
                    <div className="settings-box-top">
                        <span>{accountSettings.email}</span>
                        <div className="settings-edit-button" onClick={() => setShowEmailForm(!showEmailForm)}>Zmień</div>
                    </div>
                    <Modal isOpen={showEmailForm} onClose={() => setShowEmailForm(false)}>
                        <span>
                            Ze względów bezpieczeństwa, zmiana e-mailu jest możliwa tylko poprzez kontakt na adres: <br></br>
                            <h3>konto@lumestore.pl</h3>
                        </span>
                    </Modal>
                </div>


            </div>

            {/*/!* Newsletter *!/*/}
            {/*<div className="settings-section">*/}
            {/*    <h2 className="settings-subtitle">Newsletter</h2>*/}
            {/*    <div className="newsletter-wrapper">*/}
            {/*        <Checkbox*/}
            {/*            checked={accountSettings.receiveNewsletter}*/}
            {/*            onChange={() => setAccountSettings({...accountSettings, receiveNewsletter: !accountSettings.receiveNewsletter})}*/}
            {/*        />*/}
            {/*        <span>Chcę otrzymywać newsletter</span>*/}

            {/*    </div>*/}
                <div id='newsletter-bttn' onClick={saveNewSettings}>Zapisz zmiany</div>
            {/*</div>*/}

            {/* Delete account */}
            <div className="settings-section">
                <h2 className="settings-subtitle">Usuwanie konta</h2>

                <div id="delete-account-bttn" onClick={() => setShowDeleteModal(true)}>Usuń konto</div>
            </div>


            <Modal isOpen={showDeleteModal} onClose={() => setShowDeleteModal(false)}>
                    <span id="delete-account-label-1">
                   Kliknięcie tego przycisku nie usuwa konta automatycznie.<br></br>

                    Aby trwale usunąć swoje konto w naszym sklepie, skontaktuj się z nami pod adresem:<br></br>
                    <h3>konto@lumestore.pl</h3><br></br>

Usunięcie konta jest <b>nieodwracalne</b> — upewnij się, że naprawdę chcesz to zrobić.
                </span>
            </Modal>
        </div>
    );
}
